import { useContext } from 'react'

import { UserDispatchContext } from '../../constants'

const useUserDispatch = () => {
    const context = useContext(UserDispatchContext)

    if (context === undefined) {
        throw new Error('UserDispatchContext must be within provider')
    }

    return context
}

export default useUserDispatch
